export default __webpack_public_path__ + "4c6537dc28f4389ca9588c7e44f989da.svg";